(function () {
  'use strict';

  if (window.LoantiProductQuiz && window.LoantiProductQuiz.bootstrapped) {
    return;
  }

  var SCROLL_LOCK_CLASS = 'loanti-product-quiz-scroll-lock';
  var FOCUSABLE =
    'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function parseData(root) {
    var el = root.querySelector('[data-loanti-product-quiz-data]');
    if (!el) {
      return null;
    }

    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      return null;
    }
  }

  function canOpenQuiz() {
    var html = document.documentElement;
    return !(
      html.classList.contains('js-drawer-open') ||
      html.classList.contains('modal-open') ||
      html.classList.contains('loanti-age-gate-active')
    );
  }

  function Quiz(root) {
    this.root = root;
    this.data = parseData(root);
    this.openBtn = root.querySelector('[data-loanti-product-quiz-open]');
    this.dialog = root.querySelector('[data-loanti-product-quiz-dialog]');
    this.overlay = root.querySelector('[data-loanti-product-quiz-overlay]');
    this.panel = root.querySelector('[data-loanti-product-quiz-panel]');
    this.stepsEl = root.querySelector('[data-loanti-product-quiz-steps]');
    this.progressEl = root.querySelector('[data-loanti-product-quiz-progress]');
    this.resultEl = root.querySelector('[data-loanti-product-quiz-result]');
    this.resultLevelEl = root.querySelector('[data-loanti-product-quiz-result-level]');
    this.resultDescEl = root.querySelector('[data-loanti-product-quiz-result-desc]');
    this.backBtn = root.querySelector('[data-loanti-product-quiz-back]');
    this.nextBtn = root.querySelector('[data-loanti-product-quiz-next]');
    this.restartBtn = root.querySelector('[data-loanti-product-quiz-restart]');
    this.returnBtn = root.querySelector('[data-loanti-product-quiz-return]');
    this.closeBtns = root.querySelectorAll('[data-loanti-product-quiz-close]');

    this.isOpen = false;
    this.stepIndex = 0;
    this.answers = {};
    this.showingResult = false;
    this.lastFocused = null;
    this.prevHtmlOverflow = '';
    this.prevBodyOverflow = '';

    this.onKeyDown = this.onKeyDown.bind(this);
    this.onDocumentKeyDown = this.onDocumentKeyDown.bind(this);
    this.onForeignOverlay = this.onForeignOverlay.bind(this);
    this.onAnswerChange = this.onAnswerChange.bind(this);

    if (
      !this.data ||
      !this.data.questions ||
      !this.data.scores ||
      !this.data.sectionId ||
      !this.data.productId ||
      !this.openBtn ||
      !this.dialog ||
      !this.stepsEl ||
      !this.backBtn ||
      !this.nextBtn ||
      !this.restartBtn ||
      !this.returnBtn
    ) {
      return;
    }

    this.bind();
    this.renderSteps();
    this.updateView();
  }

  Quiz.prototype.bind = function () {
    var self = this;

    this.openBtn.addEventListener('click', function () {
      self.open();
    });

    this.closeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.close();
      });
    });

    if (this.overlay) {
      this.overlay.addEventListener('click', function () {
        self.close();
      });
    }

    if (this.panel) {
      this.panel.addEventListener('click', function (event) {
        event.stopPropagation();
      });
    }

    this.backBtn.addEventListener('click', function () {
      self.goBack();
    });

    this.nextBtn.addEventListener('click', function () {
      self.goNext();
    });

    this.restartBtn.addEventListener('click', function () {
      self.restart();
    });

    this.returnBtn.addEventListener('click', function () {
      self.close();
    });

    this.dialog.addEventListener('keydown', this.onKeyDown);
    this.stepsEl.addEventListener('change', this.onAnswerChange);
  };

  Quiz.prototype.idPrefix = function () {
    return 'loanti-quiz-' + this.data.sectionId + '-' + this.data.productId;
  };

  Quiz.prototype.radioName = function (questionId) {
    return this.idPrefix() + '-' + questionId;
  };

  Quiz.prototype.radioInputId = function (answerId) {
    return this.idPrefix() + '-' + answerId;
  };

  Quiz.prototype.renderSteps = function () {
    var self = this;
    this.stepsEl.innerHTML = '';

    this.data.questions.forEach(function (question, index) {
      var step = document.createElement('div');
      step.className = 'loanti-product-quiz__step';
      step.setAttribute('data-loanti-product-quiz-step', String(index));
      step.hidden = index !== 0;

      var fieldset = document.createElement('fieldset');
      fieldset.className = 'loanti-product-quiz__fieldset';

      var legend = document.createElement('legend');
      legend.className = 'loanti-product-quiz__legend';
      legend.textContent = question.text;
      fieldset.appendChild(legend);

      var list = document.createElement('div');
      list.className = 'loanti-product-quiz__answers';

      var groupName = self.radioName(question.id);

      question.answers.forEach(function (answer) {
        var option = document.createElement('div');
        option.className = 'loanti-product-quiz__option';

        var inputId = self.radioInputId(answer.id);
        var input = document.createElement('input');
        input.type = 'radio';
        input.className = 'loanti-product-quiz__radio';
        input.name = groupName;
        input.id = inputId;
        input.value = answer.id;
        input.setAttribute('data-question-id', question.id);
        input.setAttribute('data-answer-id', answer.id);

        var label = document.createElement('label');
        label.className = 'loanti-product-quiz__answer';
        label.setAttribute('for', inputId);
        label.textContent = answer.label;

        option.appendChild(input);
        option.appendChild(label);
        list.appendChild(option);
      });

      fieldset.appendChild(list);
      step.appendChild(fieldset);
      self.stepsEl.appendChild(step);
    });
  };

  Quiz.prototype.onAnswerChange = function (event) {
    var input = event.target;
    if (!input || input.type !== 'radio') {
      return;
    }

    var questionId = input.getAttribute('data-question-id');
    var answerId = input.getAttribute('data-answer-id') || input.value;
    if (!questionId || !answerId) {
      return;
    }

    this.answers[questionId] = answerId;
    this.updateFooter();
  };

  Quiz.prototype.currentQuestion = function () {
    return this.data.questions[this.stepIndex];
  };

  Quiz.prototype.syncRadiosFromAnswers = function () {
    var self = this;

    this.data.questions.forEach(function (question) {
      var selectedId = self.answers[question.id];
      if (!selectedId) {
        return;
      }

      self.root.querySelectorAll('.loanti-product-quiz__radio').forEach(function (input) {
        if (input.getAttribute('data-answer-id') === selectedId) {
          input.checked = true;
        }
      });
    });
  };

  Quiz.prototype.clearRadios = function () {
    this.stepsEl.querySelectorAll('.loanti-product-quiz__radio').forEach(function (input) {
      input.checked = false;
    });
  };

  Quiz.prototype.updateView = function () {
    var self = this;
    var total = this.data.questions.length;

    this.stepsEl.hidden = this.showingResult;
    this.resultEl.hidden = !this.showingResult;

    if (!this.showingResult) {
      this.progressEl.hidden = false;
      this.progressEl.textContent = 'Pytanie ' + (this.stepIndex + 1) + ' z ' + total;

      this.stepsEl.querySelectorAll('[data-loanti-product-quiz-step]').forEach(function (step) {
        var index = parseInt(step.getAttribute('data-loanti-product-quiz-step'), 10);
        step.hidden = index !== self.stepIndex;
      });

      this.syncRadiosFromAnswers();
    } else {
      this.progressEl.hidden = true;
    }

    this.updateFooter();
  };

  Quiz.prototype.updateFooter = function () {
    var total = this.data.questions.length;
    var question = this.currentQuestion();
    var hasAnswer = question ? Boolean(this.answers[question.id]) : false;
    var isLast = this.stepIndex >= total - 1;

    if (this.showingResult) {
      this.backBtn.hidden = true;
      this.nextBtn.hidden = true;
      this.restartBtn.hidden = false;
      this.returnBtn.hidden = false;
      return;
    }

    this.restartBtn.hidden = true;
    this.returnBtn.hidden = true;
    this.backBtn.hidden = this.stepIndex === 0;
    this.nextBtn.hidden = false;
    this.nextBtn.disabled = !hasAnswer;
    this.nextBtn.textContent = isLast ? 'Zobacz wynik' : 'Dalej';
  };

  Quiz.prototype.goBack = function () {
    if (this.showingResult || this.stepIndex === 0) {
      return;
    }

    this.stepIndex -= 1;
    this.updateView();
    this.focusFirstInStep();
  };

  Quiz.prototype.goNext = function () {
    var question = this.currentQuestion();
    if (!question || !this.answers[question.id]) {
      return;
    }

    if (this.stepIndex >= this.data.questions.length - 1) {
      this.showResult();
      return;
    }

    this.stepIndex += 1;
    this.updateView();
    this.focusFirstInStep();
  };

  Quiz.prototype.calcScore = function () {
    var self = this;
    var total = 0;

    this.data.questions.forEach(function (question) {
      var answerId = self.answers[question.id];
      if (!answerId) {
        return;
      }

      var points = self.data.scores[answerId];
      if (typeof points === 'number') {
        total += points;
      }
    });

    return total;
  };

  Quiz.prototype.resolveResult = function (score) {
    if (score >= 7) {
      return this.data.results.high;
    }
    if (score >= 4) {
      return this.data.results.medium;
    }
    return this.data.results.low;
  };

  Quiz.prototype.showResult = function () {
    var result = this.resolveResult(this.calcScore());
    this.showingResult = true;
    this.resultLevelEl.textContent = result.title;
    this.resultDescEl.textContent = result.description;
    this.updateView();

    if (this.returnBtn) {
      this.returnBtn.focus();
    }
  };

  Quiz.prototype.restart = function () {
    this.stepIndex = 0;
    this.answers = {};
    this.showingResult = false;
    this.clearRadios();
    this.updateView();
    this.focusFirstInStep();
  };

  Quiz.prototype.lockScroll = function () {
    var html = document.documentElement;
    var body = document.body;

    this.prevHtmlOverflow = html.style.overflow;
    this.prevBodyOverflow = body.style.overflow;

    html.classList.add(SCROLL_LOCK_CLASS);
    html.style.overflow = 'hidden';
    body.style.overflow = 'hidden';
  };

  Quiz.prototype.unlockScroll = function () {
    var html = document.documentElement;
    var body = document.body;

    html.classList.remove(SCROLL_LOCK_CLASS);
    html.style.overflow = this.prevHtmlOverflow;
    body.style.overflow = this.prevBodyOverflow;
  };

  Quiz.prototype.isDisplayed = function (el) {
    if (!el || el.hasAttribute('hidden') || el.disabled) {
      return false;
    }

    var node = el;
    while (node && node !== this.dialog) {
      if (node.hasAttribute && node.hasAttribute('hidden')) {
        return false;
      }
      node = node.parentElement;
    }

    var style = window.getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden';
  };

  Quiz.prototype.getFocusable = function () {
    if (!this.dialog) {
      return [];
    }

    var self = this;
    return Array.prototype.slice.call(this.dialog.querySelectorAll(FOCUSABLE)).filter(function (el) {
      return self.isDisplayed(el);
    });
  };

  Quiz.prototype.focusFirstInStep = function () {
    var step = this.stepsEl.querySelector('[data-loanti-product-quiz-step]:not([hidden])');
    if (!step) {
      return;
    }

    var checked = step.querySelector('.loanti-product-quiz__radio:checked');
    var first = checked || step.querySelector('.loanti-product-quiz__radio');
    if (first) {
      first.focus();
    }
  };

  Quiz.prototype.onKeyDown = function (event) {
    if (!this.isOpen || event.key !== 'Tab') {
      return;
    }

    var focusable = this.getFocusable();
    if (!focusable.length) {
      event.preventDefault();
      return;
    }

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  Quiz.prototype.onDocumentKeyDown = function (event) {
    if (event.key === 'Escape' || event.keyCode === 27) {
      this.close();
    }
  };

  Quiz.prototype.onForeignOverlay = function () {
    if (this.isOpen) {
      this.close();
    }
  };

  Quiz.prototype.open = function () {
    if (this.isOpen || !canOpenQuiz()) {
      return;
    }

    this.lastFocused = document.activeElement;
    this.isOpen = true;
    this.dialog.hidden = false;
    this.dialog.setAttribute('aria-hidden', 'false');
    this.lockScroll();

    document.addEventListener('keydown', this.onDocumentKeyDown);
    document.addEventListener('drawerOpen', this.onForeignOverlay);
    document.addEventListener('modalOpen', this.onForeignOverlay);

    this.updateView();
    this.focusFirstInStep();
  };

  Quiz.prototype.close = function () {
    if (!this.isOpen) {
      return;
    }

    this.isOpen = false;
    this.dialog.hidden = true;
    this.dialog.setAttribute('aria-hidden', 'true');
    this.unlockScroll();

    document.removeEventListener('keydown', this.onDocumentKeyDown);
    document.removeEventListener('drawerOpen', this.onForeignOverlay);
    document.removeEventListener('modalOpen', this.onForeignOverlay);

    if (this.lastFocused && typeof this.lastFocused.focus === 'function') {
      this.lastFocused.focus();
    } else if (this.openBtn) {
      this.openBtn.focus();
    }
  };

  function initRoot(root) {
    if (!root || root.getAttribute('data-loanti-product-quiz-ready') === '1') {
      return;
    }

    root.setAttribute('data-loanti-product-quiz-ready', '1');
    new Quiz(root);
  }

  function initAll() {
    document.querySelectorAll('[data-loanti-product-quiz]').forEach(initRoot);
  }

  window.LoantiProductQuiz = {
    bootstrapped: true,
    initAll: initAll
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
